export const GameDetailsTabType = {
  SETTINGS: 0,
  TRANSLATIONS: 1,
};
